import React from "react";
import AdminOltVlansComponent from "../components/admin/AdminOltVlansComponent";

const AdminOltVlansPage: React.FC = () => {
  return (
    <div>
      <AdminOltVlansComponent />
    </div>
  );
};

export default AdminOltVlansPage;
